export const filesPublicationPlaceholder = `debug/bin/setup.exe
target/
reports/coverage/*.html
`
